module.exports = __webpack_public_path__ + "static/polydigi-79662d2745a466bfb3bb2aac859d0f4d.jpeg";